type InteractionType = 'SwipeFull' | 'SwipeHalf';

window.o_order.basket.initSwipeToDelete = function (): void {

    const SELECTORS = {
        wrapper: '.order_js_basketItem-swipe-wrapper',
        inner: '.order_js_basketItem-swipe-inner',
        deleteButton: '.order_js_basketItem-swipe-delete-button',
        basketItem: '.order_js_item',
    };

    function initialize(): void {
        attachSwipeHandlers();
        attachDeleteButtonHandlers();
    }

    function attachSwipeHandlers(): void {
        const swipeableItems = Array.from(document.querySelectorAll<HTMLDivElement>(SELECTORS.wrapper));

        swipeableItems.forEach((item) => {
            item.addEventListener('scrollend', event => {
                const target = event.target as HTMLElement | null;

                if (!target) {
                    return;
                }
                const itemToDelete: HTMLElement | null = target?.closest(SELECTORS.wrapper);
                if (!itemToDelete) {
                    return;
                }
                const scrollLeft = target.scrollLeft;
                const itemWidth = itemToDelete.offsetWidth;
                if (scrollLeft < itemWidth + 5 && scrollLeft > itemWidth - 5) {
                    handleRemove(itemToDelete, 'SwipeFull');
                }
            });

            item.addEventListener('touchstart', () => {
                resetScrollOnOtherItems(item, swipeableItems);
            });
        });
    }

    function attachDeleteButtonHandlers(): void {
        const buttons = Array.from(document.querySelectorAll<HTMLButtonElement>(SELECTORS.deleteButton));

        buttons.forEach((button) => {
            const container = button.closest(SELECTORS.wrapper) as HTMLElement | null;
            button.addEventListener('click', () => {
                if (container) {handleRemove(container, 'SwipeHalf');}
            });
        });
    }

    function resetScrollOnOtherItems(currentItem: HTMLElement, allItems: HTMLElement[]): void {
        allItems
            .filter(item => item !== currentItem)
            .forEach(item => item.scrollTo({ left: 0, behavior: 'smooth' }));
    }

    function handleRemove(container: HTMLElement, interactionType: InteractionType): void {
        container.style.visibility = 'hidden';

        const itemElement = container.querySelector<HTMLElement>(SELECTORS.basketItem);
        const itemId = itemElement?.dataset.basketitemid;

        if (!itemId) {
            return;
        }

        o_global.eventQBus.emit('ft1.order-core.deleteBasketItem', {
            basketItemId: itemId,
            interactionType: interactionType
        })
        animateCollapse(container);
    }

    function animateCollapse(container: HTMLElement): void {
        const sectionHeight = container.scrollHeight;
        const inner = container.querySelector<HTMLElement>(SELECTORS.inner);

        requestAnimationFrame(() => {
            container.style.height = `${sectionHeight}px`;
            container.style.transition = 'height 0.2s ease-out';
            if (inner) {inner.style.display = 'none';}

            requestAnimationFrame(() => {
                container.style.height = '0px';
            });
        });
    }

    initialize();
};
